import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-6 lg:grid-cols-2" }
const _hoisted_3 = { class: "size-lf-stretch p-4 bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-zinc-200 inline-flex flex-col justify-start items-start gap-4 overflow-hidden" }
const _hoisted_4 = { class: "self-stretch flex-1 flex flex-col justify-between items-start" }
const _hoisted_5 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_6 = { class: "gray-iron-700 text-sm" }
const _hoisted_7 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_8 = { class: "gray-iron-700 text-sm" }
const _hoisted_9 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_10 = { class: "gray-iron-700 text-sm" }
const _hoisted_11 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_12 = { class: "gray-iron-700 text-sm" }
const _hoisted_13 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_14 = { class: "gray-iron-700 text-sm" }
const _hoisted_15 = { class: "inline-flex flex-col items-start justify-start gap-3 self-stretch rounded-[10px] bg-white p-4 outline outline-1 outline-offset-[-1px] outline-zinc-200" }
const _hoisted_16 = { class: "inline-flex flex-col items-start justify-start gap-2 self-stretch rounded-lg bg-neutral-50 p-3 outline outline-1 outline-offset-[-1px] outline-zinc-200" }
const _hoisted_17 = { class: "inline-flex items-center justify-between self-stretch rounded-lg bg-yellow-100 p-3" }
const _hoisted_18 = { class: "justify-start text-lg font-bold leading-7 text-yellow-700" }
const _hoisted_19 = { class: "inline-flex flex-col items-start justify-start gap-2 self-stretch rounded-lg bg-neutral-50 p-3 outline outline-1 outline-offset-[-1px] outline-zinc-200" }
const _hoisted_20 = { class: "inline-flex items-center justify-between self-stretch rounded-lg bg-yellow-100 p-3" }
const _hoisted_21 = { class: "justify-start text-lg font-bold leading-7 text-blue-700" }
const _hoisted_22 = { class: "grid grid-cols-1 gap-6 lg:grid-cols-2" }
const _hoisted_23 = { class: "self-stretch p-4 bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-zinc-200 inline-flex flex-col justify-start items-center gap-4 overflow-hidden" }
const _hoisted_24 = { class: "self-stretch p-3 bg-emerald-50 rounded-lg inline-flex justify-between items-center" }
const _hoisted_25 = { class: "justify-start text-green-700 text-lg font-bold leading-7" }
const _hoisted_26 = { class: "self-stretch inline-flex justify-start items-start gap-4" }
const _hoisted_27 = { class: "flex-1 inline-flex flex-col justify-start items-center gap-4" }
const _hoisted_28 = { class: "self-stretch p-3 bg-neutral-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-zinc-200 flex flex-col justify-start items-start gap-3" }
const _hoisted_29 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_30 = {
  "data-color": "Gray",
  "data-icon": "False",
  "data-size": "md",
  "data-type": "Pill outline",
  class: "px-2.5 py-0.5 bg-emerald-50 rounded-2xl outline outline-[1.50px] outline-offset-[-1.50px] outline-emerald-300 flex justify-start items-center"
}
const _hoisted_31 = { class: "text-center justify-start text-slate-700 text-sm font-medium leading-tight" }
const _hoisted_32 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_33 = {
  "data-color": "Gray",
  "data-icon": "False",
  "data-size": "md",
  "data-type": "Pill outline",
  class: "px-2.5 py-0.5 bg-gray-50 rounded-2xl outline outline-[1.50px] outline-offset-[-1.50px] outline-gray-300 flex justify-start items-center"
}
const _hoisted_34 = { class: "text-center justify-start text-slate-700 text-sm font-medium leading-tight" }
const _hoisted_35 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_36 = {
  "data-color": "Gray",
  "data-icon": "False",
  "data-size": "md",
  "data-type": "Pill outline",
  class: "px-2.5 py-0.5 bg-blue-50 rounded-2xl outline outline-[1.50px] outline-offset-[-1.50px] outline-blue-300 flex justify-start items-center"
}
const _hoisted_37 = { class: "text-center justify-start text-slate-700 text-sm font-medium leading-tight" }
const _hoisted_38 = { class: "self-stretch p-4 bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-zinc-200 inline-flex flex-col justify-center items-center gap-3 overflow-hidden" }
const _hoisted_39 = { class: "self-stretch p-3 bg-blue-50 rounded-lg inline-flex justify-between items-center" }
const _hoisted_40 = { class: "justify-start text-blue-700 text-lg font-bold leading-7" }
const _hoisted_41 = { class: "self-stretch inline-flex justify-start items-start gap-4" }
const _hoisted_42 = { class: "flex-1 inline-flex flex-col justify-start items-center gap-4" }
const _hoisted_43 = { class: "self-stretch p-3 bg-neutral-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-zinc-200 flex flex-col justify-start items-start gap-4" }
const _hoisted_44 = { class: "self-stretch inline-flex justify-between items-center" }
const _hoisted_45 = {
  "data-color": "Gray",
  "data-icon": "False",
  "data-size": "md",
  "data-type": "Pill outline",
  class: "px-2.5 py-0.5 bg-blue-50 rounded-2xl outline outline-[1.50px] outline-offset-[-1.50px] outline-blue-300 flex justify-start items-center"
}
const _hoisted_46 = { class: "text-center justify-start text-slate-700 text-sm font-medium leading-tight" }
const _hoisted_47 = { class: "self-stretch flex flex-col justify-start items-start gap-2" }
const _hoisted_48 = { class: "self-stretch p-3 bg-emerald-50 rounded-lg inline-flex justify-between items-center" }
const _hoisted_49 = { class: "justify-start text-green-700 text-xl font-bold leading-loose" }
const _hoisted_50 = { class: "self-stretch p-3 bg-yellow-50 rounded-lg inline-flex justify-between items-center" }
const _hoisted_51 = { class: "justify-start text-yellow-700 text-xl font-bold leading-loose" }

import { computed } from 'vue';

import DefaultChip from './DefaultChip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FinancingSegmentView',
  props: {
    segment: {}
  },
  setup(__props: any) {

const props = __props;

const pricingRules = computed(() => {
  const rules = props.segment?.rules || [];

  const findRuleBySlug = (slug: string) => rules.find((r: any) => r.slug === slug);

  return {
    netPrice: findRuleBySlug('cena-netto-dla-klienta-wszystkie-technologie'),
    grossPrice: findRuleBySlug('cena-brutto-dla-klienta-wszystkie-technologie'),
    subsidy: findRuleBySlug('dotacja'),
    clientContribution: findRuleBySlug('kwota-po-dotacji-wklad-wlasny-klienta'),
    thermalDeduction: findRuleBySlug('ulga-termomodernizacyjna-do-odliczenia'),
  };
});

const paymentRules = computed(() => {
  const rules = props.segment?.rules || [];

  const findRuleBySlug = (slug: string) => rules.find((r: any) => r.slug === slug);

  return {
    vatPayment: findRuleBySlug('platnosc-1-vat-od-pierwszej-transzy-dotacji-klient'),
    firstSubsidy: findRuleBySlug('platnosc-2-pierwsza-transza-dotacji-35percent-wfos'),
    secondSubsidy: findRuleBySlug('platnosc-3-druga-transza-dotacji-wfos-po-montazu-i-oplaceniu-faktury-koncowej'),
    clientPaymentAfterInstallation: findRuleBySlug('platnosc-4-wklad-wlasny-klienta-klient-po-montazu'),
  };
});

const financingOptions = computed(() => {
  const rules = props.segment?.rules || [];

  const findRuleBySlug = (slug: string) => rules.find((r: any) => r.slug === slug);

  return {
    cashPaymentOption1: rules.find((r: any) => r.slug === 'wariant-1-klient-placi-gotowka' && r.order === 10),
    cashPaymentOption2: rules.find((r: any) => r.slug === 'wariant-1-klient-placi-gotowka' && r.order === 14),
    trifyInterestRate: findRuleBySlug('wariant-2-rata-trify-odsetkowa'),
    trifyLastPayment: findRuleBySlug('wariant-2-rata-trify-ostatnia'),
    externalFinancing: findRuleBySlug('wariant-2-rata-finansowanie-zewnetrzne'),
  };
});

const groupRules = computed(() => {
  const groups = props.segment?.groups || [];
  const allGroupRules = groups.flatMap((group: any) => group.rules || []);

  const findGroupRuleBySlug = (slug: string) => allGroupRules.find((r: any) => r.slug === slug);

  return {
    loanAmount: findGroupRuleBySlug('kwota-kredytu-netto-do-wyplaty'),
    installmentCount: findGroupRuleBySlug('liczba-rat'),
    interestRate: findGroupRuleBySlug('oprocentowanie-nominalne-w-skali-roku'),
  };
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "justify-start text-gray-900 text-base font-bold leading-normal" }, "Podsumowanie ceny", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(pricingRules.value.netPrice?.name || 'Cena netto'), 1),
            _createVNode(DefaultChip, {
              class: "text-sm",
              variant: "gray"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(pricingRules.value.netPrice?.eval || '-') + " " + _toDisplayString(pricingRules.value.netPrice?.unit), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(pricingRules.value.grossPrice?.name || 'Cena brutto'), 1),
            _createVNode(DefaultChip, {
              class: "text-sm",
              variant: "yellow"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(pricingRules.value.grossPrice?.eval || '-') + " " + _toDisplayString(pricingRules.value.grossPrice?.unit), 1)
              ]),
              _: 1
            })
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "self-stretch h-px bg-zinc-200" }, null, -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(pricingRules.value.subsidy?.name), 1),
            _createVNode(DefaultChip, {
              class: "text-sm",
              variant: "green"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(pricingRules.value.subsidy?.eval || '-') + " " + _toDisplayString(pricingRules.value.subsidy?.unit), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(pricingRules.value.clientContribution?.name || 'Kwota po dotacji (wkład klienta)'), 1),
            _createVNode(DefaultChip, {
              class: "text-sm",
              variant: "green"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(pricingRules.value.clientContribution?.eval || '-') + " " + _toDisplayString(pricingRules.value.clientContribution?.unit), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(pricingRules.value.thermalDeduction?.name || 'Ulga termomodernizacyjna do odliczenia'), 1),
            _createVNode(DefaultChip, { variant: "blue" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(pricingRules.value.thermalDeduction?.eval || '-') + " " + _toDisplayString(pricingRules.value.thermalDeduction?.unit), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-base font-bold text-gray-900" }, "Proces płatności", -1)),
        _createElementVNode("div", _hoisted_16, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-base font-normal text-zinc-700" }, " Pierwsza płatność - zaliczka po otrzymaniu pozytywnego rozpatrzenia wniosku ", -1)),
          _createElementVNode("div", _hoisted_17, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "size- inline-flex flex-col items-start justify-center" }, [
              _createElementVNode("div", { class: "justify-start text-base font-medium leading-normal text-zinc-900" }, " VAT (od pierwszej transzy dotacji) "),
              _createElementVNode("div", { class: "justify-start text-sm font-normal leading-tight text-zinc-700" }, " Klient na podstawie faktury ")
            ], -1)),
            _createElementVNode("div", _hoisted_18, _toDisplayString(paymentRules.value.vatPayment?.eval || '-') + " " + _toDisplayString(paymentRules.value.vatPayment?.unit), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-base font-normal text-zinc-700" }, "Po opłaceniu VAT-u przez klienta", -1)),
          _createElementVNode("div", _hoisted_20, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "size- inline-flex flex-col items-start justify-center" }, [
              _createElementVNode("div", { class: "justify-start text-base font-medium leading-normal text-zinc-900" }, " Pierwsza transza dotacji (35%) "),
              _createElementVNode("div", { class: "justify-start text-sm font-normal leading-tight text-zinc-700" }, " Wypłaca WFOŚiGW ")
            ], -1)),
            _createElementVNode("div", _hoisted_21, _toDisplayString(paymentRules.value.firstSubsidy?.eval || '-') + " " + _toDisplayString(paymentRules.value.firstSubsidy?.unit), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "inline-flex flex-col justify-center items-start" }, [
            _createElementVNode("div", { class: "justify-start text-zinc-900 text-base font-medium leading-normal" }, "Wkład własny klienta"),
            _createElementVNode("div", { class: "justify-start text-zinc-700 text-sm font-normal leading-tight" }, "Klient na podstawie faktury")
          ], -1)),
          _createElementVNode("div", _hoisted_25, _toDisplayString(groupRules.value.loanAmount?.eval || paymentRules.value.clientPaymentAfterInstallation?.eval || '-') + " " + _toDisplayString(groupRules.value.loanAmount?.unit || paymentRules.value.clientPaymentAfterInstallation?.unit || ''), 1)
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "justify-start text-zinc-700 text-base font-normal leading-normal" }, "Dwie możliwości finansowania", -1)),
        _createElementVNode("div", _hoisted_26, [
          _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"flex-1 self-stretch inline-flex flex-col justify-start items-center gap-4\"><div class=\"justify-start text-zinc-700 text-base font-normal leading-normal\">Opcja 1</div><div class=\"self-stretch flex-1 p-3 bg-neutral-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-zinc-200 flex flex-col justify-center items-center gap-2\"><div class=\"w-10 h-10 relative overflow-hidden\"><div class=\"w-7 h-5 left-[6.12px] top-[8.12px] absolute outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div><div class=\"w-7 h-5 left-[11.10px] top-[13.10px] absolute opacity-40 outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div><div class=\"w-0.5 h-0 left-[10.86px] top-[23.74px] absolute outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div><div class=\"w-1.5 h-1.5 left-[16.02px] top-[15.14px] absolute outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div><div class=\"w-0.5 h-0 left-[25.84px] top-[13.28px] absolute outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div></div><div class=\"justify-start text-zinc-900 text-base font-medium leading-normal\">Klient płaci gotówką</div></div></div>", 1)),
          _createElementVNode("div", _hoisted_27, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "justify-start text-zinc-700 text-base font-normal leading-normal" }, "Opcja 2", -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "justify-start text-zinc-700 text-base font-normal leading-normal" }, "RRSO", -1)),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(groupRules.value.interestRate?.eval || '-') + _toDisplayString(groupRules.value.interestRate?.unit || ''), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "justify-start text-zinc-700 text-base font-normal leading-normal" }, "Liczba miesięcy", -1)),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(Math.floor(Number(groupRules.value.installmentCount?.eval)) || '-'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "justify-start text-zinc-700 text-base font-normal leading-normal" }, "Rata miesięczna", -1)),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(financingOptions.value.externalFinancing?.eval || '-') + " " + _toDisplayString(financingOptions.value.externalFinancing?.unit || ''), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-1 inline-flex flex-col justify-center items-start" }, [
            _createElementVNode("div", { class: "self-stretch justify-start text-zinc-900 text-base font-medium leading-normal" }, "Druga transza dotacji wypłacona przez WFOŚiGW po montażu i opłaceniu faktury końcowej"),
            _createElementVNode("div", { class: "justify-start text-zinc-700 text-sm font-normal leading-tight" }, "Gotówka / pożyczka pomostowa")
          ], -1)),
          _createElementVNode("div", _hoisted_40, _toDisplayString(paymentRules.value.secondSubsidy?.eval || '-') + " " + _toDisplayString(paymentRules.value.secondSubsidy?.unit || ''), 1)
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "justify-start text-zinc-700 text-base font-normal leading-normal" }, "Dwie możliwości finansowania", -1)),
        _createElementVNode("div", _hoisted_41, [
          _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"flex-1 self-stretch inline-flex flex-col justify-start items-center gap-4\"><div class=\"justify-start text-zinc-700 text-base font-normal leading-normal\">Opcja 1</div><div class=\"self-stretch flex-1 p-3 bg-neutral-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-zinc-200 flex flex-col justify-center items-center gap-2\"><div class=\"w-10 h-10 relative overflow-hidden\"><div class=\"w-7 h-5 left-[6.12px] top-[8.12px] absolute outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div><div class=\"w-7 h-5 left-[11.10px] top-[13.10px] absolute opacity-40 outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div><div class=\"w-0.5 h-0 left-[10.86px] top-[23.74px] absolute outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div><div class=\"w-1.5 h-1.5 left-[16.02px] top-[15.14px] absolute outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div><div class=\"w-0.5 h-0 left-[25.84px] top-[13.28px] absolute outline outline-[2.62px] outline-offset-[-1.31px] outline-zinc-500\"></div></div><div class=\"justify-start text-zinc-900 text-base font-medium leading-normal\">Klient płaci gotówką</div><div class=\"self-stretch text-center justify-start text-zinc-700 text-sm font-normal leading-tight\">Druga transza dotacji będzie przelana na konto Beneficjenta</div></div></div>", 1)),
          _createElementVNode("div", _hoisted_42, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "justify-start text-zinc-700 text-base font-normal leading-normal" }, "Opcja 2", -1)),
            _createElementVNode("div", _hoisted_43, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "self-stretch flex flex-col justify-start items-start gap-2" }, [
                _createElementVNode("div", { class: "self-stretch text-center justify-start text-zinc-900 text-base font-medium leading-normal" }, "Uruchamiamy pożyczkę pomostową (Trify), w której klient płaci samą ratę odsetkową bez spłaty kapitału do czasu wypłaty drugiej transzy dotacji z WFOŚiGW "),
                _createElementVNode("div", { class: "self-stretch text-center justify-start text-zinc-700 text-sm font-normal leading-tight" }, "Druga transza dotacji spłaca pożyczkę pomostową i ją zamyka ")
              ], -1)),
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "self-stretch h-px bg-zinc-200" }, null, -1)),
              _createElementVNode("div", _hoisted_44, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "justify-start text-zinc-700 text-base font-normal leading-normal" }, "Rata miesięczna", -1)),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, _toDisplayString(financingOptions.value.trifyInterestRate?.eval || '-') + " " + _toDisplayString(financingOptions.value.trifyInterestRate?.unit || ''), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "justify-start text-zinc-900 text-base font-medium leading-normal" }, "Do odliczenia ulga termomodernizacyjna w podatku dochodowym", -1)),
        _createElementVNode("div", _hoisted_49, _toDisplayString(pricingRules.value.thermalDeduction?.eval || '-') + " " + _toDisplayString(pricingRules.value.thermalDeduction?.unit || ''), 1)
      ]),
      _createElementVNode("div", _hoisted_50, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "inline-flex flex-col justify-center items-start" }, [
          _createElementVNode("div", { class: "justify-start text-zinc-900 text-base font-bold leading-normal" }, "Cena finalna"),
          _createElementVNode("div", { class: "justify-start text-zinc-700 text-sm font-normal leading-tight" }, "Po dotacjach i ulgach brutto")
        ], -1)),
        _createElementVNode("div", _hoisted_51, _toDisplayString(groupRules.value.loanAmount?.eval || pricingRules.value.clientContribution?.eval || '-') + " " + _toDisplayString(groupRules.value.loanAmount?.unit || pricingRules.value.clientContribution?.unit || ''), 1)
      ])
    ])
  ]))
}
}

})